import styled from "@emotion/styled";
import { IconLetter } from '@kompare/kompare-ui-library';
import { useEffect } from 'react';
import { i18n, mediaQuery, showMessage, useFinishOfflinePurchase, useGeneralSoContext } from 'src/common';
import { useGetOffer } from 'src/common/apiGraphql/queries/useGetOffer.query';
import { Button, Flex, StatusMessage } from 'src/components';
import config from 'src/config';
import { colors, footer, header } from 'src/theme';

const ButtonContainerStyle = styled.div({
  marginTop: 32,
  textAlign: 'center',
});

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const CheckoutSuccessOfflinePage = () => {

  const { offerId, soId } = useGeneralSoContext();
  const { offer, refetch: refetchOffer } = useGetOffer();
  const [finishOfflinePurchase] = useFinishOfflinePurchase();


  useEffect(() => {
    if (!soId || !offerId) {
      return;
    }
    if (offer) {
      refetchOffer();
    }
  }, []);

  useEffect(() => {
    finishOfflinePurchase().catch(() => {
      showMessage({
        type: 'error',
        message: i18n.t('common.messages.policyErrorMessage'),
        duration: 5000,
        fixed: true
      });
    }).finally(() => {
      window.sessionStorage.clear();
    });
  }, []);


const navigateToHome = () => {
  window.location.href = config.REACT_APP_KOMPARE_HOME!;
};

const Buttons = () => (
  <ButtonContainerStyle>
    <Button btnType='primary' onClick={navigateToHome}>
      {i18n.t('pages.checkoutCongratulationsPage.returnToHomeButton')}
    </Button>
  </ButtonContainerStyle>
);

return (
  <FlexStyle justify='center' align='center'>
    <StatusMessage buttons={<Buttons />} icon={<IconLetter color={colors.icon4} />} title={i18n.t('pages.checkoutCongratulationsPage.title')} subtitle={i18n.t('pages.checkoutCongratulationsPage.subtitleOffline')} />
  </FlexStyle>
);
}

export default CheckoutSuccessOfflinePage;